export default __webpack_public_path__ + "static/media/logo.60097ea2.svg";